<template>
  <myhead :value="value" @next="next" @lookmore="more">{{
    $route.query.title || $route.meta.title
  }}</myhead>
<div class="address-list-container">
    <van-address-list
    v-model="chosenAddressId"
    :list="list"
  >
  <template v-slot:tag>
    <p class="address-list-sign">默认</p>
    <div class="editicon">
        <div class="editicon-img">
            <img src="@/assets/img/icon39.png" class="editicon-sort pointer" @click="handleSort">
            <img src="@/assets/img/icon33.png" class="editicon-del pointer" @click="handleDel">
        </div>
        <p class="editicon-edit" @click="handleEdit">编辑</p>
    </div>
  </template>
  </van-address-list>
</div>
</template>
<script setup>
import { ref } from "vue";
import {nextFn} from "@/utils/type.js";
//右箭头
const next = () => {
    nextFn()
}

const list = [
  {
    id: "1",
    name: "张三",
    tel: "13000000000",
    address: "浙江省杭州市西湖区文三路 138 号东方通信大厦 7 楼 501 室",
    isDefault: true,
  },
  {
    id: "2",
    name: "李四",
    tel: "1310000000",
    address: "浙江省杭州市拱墅区莫干山路 50 号",
  },
];

const chosenAddressId = ref("1");

const handleSort = () => {
    alert("排序,"+chosenAddressId.value)
};

const handleDel = () => {
    alert("删除")
};

const handleEdit = () => {
    alert("编辑")
};

</script>
<style scoped>
    .van-address-item {
        position: relative;
    }
    .address-list-sign {
        border: 1px solid #FF0000;
        font-size: 10px;
        color: #FF0000;
        border-radius: 5px;
        line-height: 1;
        padding: .5333vw .8vw;
        margin-left: 2.1333vw;
    }
    .editicon {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
    }
    .editicon-sort {
        width: 20px;
    }
    .editicon-del {
        width: 20px;
        margin-left: 10px;
    }
    .editicon-edit {
        color: #3F7C93;
        font-size: 14px;
        text-align: right;
        margin-top: 20px;
    }
    .van-address-list {
        padding: 0;
    }
    .van-address-item {
        height: 98px;
    }
</style>